interface GetGapChannelPerformancesCellValueInput {
    gapChannel: TrqkGapChannel;
    gapDenominator: number;
    statementId: Maybe<string>;
}

export const getGapChannelPerformancesCellValue = ({
    gapChannel,
    gapDenominator,
    statementId,
}: GetGapChannelPerformancesCellValueInput): GapChannelPerformancesCellValue => {
    const { channel_name_detection, performances_matched_total } = gapChannel;
    const performancesMatchedTotal = performances_matched_total ?? 0;

    return {
        channelNameDetection: channel_name_detection,
        gapDenominator,
        performancesMatchedTotal,
        statementId,
    };
};
